<template>
  <Header design-always hide-banner />
  <GuestHome />
</template>

<script setup>
import { onMounted } from 'vue'
import Header from '@/components/Header.vue'
import GuestHome from './components/GuestHome.vue'
import { setTrack } from '@/api/login'

onMounted(() => {
  void Promise.resolve()
    .then(() => setTrack({ position: 'homepage' }))
    .catch(() => {})
})
</script>

<style lang="scss" scoped></style>
